import DemandsPage from "~/admin/pages/demandsPage/DemandsPage";
import InfluencerPage from "~/admin/pages/influencerPage/InfluencerPage";
import CompanyPage from "~/admin/pages/companyPage/CompanyPage";
import Login from "~/admin/pages/loginPage/LoginPage";
import StatsPage from "~/admin/pages/statsPage/StatsPage";
import UsersPage from "~/admin/pages/usersPage/UsersPage";
import ContentsPage from "~/admin/pages/contentsPage/ContentsPage";
import ReportedPage from "~/admin/pages/ReportedPage/ReportedPage";
import ReportsPage from "~/admin/pages/ReportsPage/ReportsPage";
import BillsPage from "~/admin/pages/billsPage/BillsPage";

export default class AdminRoutes {
  static public = [
    {
      key: "adminLogin",
      path: "login",
      exact: true,
      component: Login,
    },
  ];

  static private = [
    {
      key: "adminUsers",
      path: "/admin/users",
      exact: true,
      component: UsersPage,
    },
    {
      key: "adminInfluencer",
      path: "/admin/influencers/:influencerId",
      exact: true,
      component: InfluencerPage,
    },
    {
      key: "adminCompany",
      path: "/admin/companies/:companyId",
      exact: true,
      component: CompanyPage,
    },
    {
      key: "adminDemands",
      path: "/admin/demands",
      exact: true,
      component: DemandsPage,
    },
    {
      key: "adminStats",
      path: "/admin",
      exact: true,
      component: StatsPage,
    },
    {
      key: "adminContents",
      path: "/admin/contents",
      exact: true,
      component: ContentsPage,
    },
    {
      key: "adminReports",
      path: "/admin/reports",
      exact: true,
      component: ReportedPage,
    },
    {
      key: "adminReports",
      path: "/admin/reports/:userId",
      exact: true,
      component: ReportsPage,
    },
    {
      key: "adminBills",
      path: "/admin/bills",
      exact: true,
      component: BillsPage,
    },
  ];
}
